module.exports = __webpack_public_path__ + "img/90501207id.829fab60.png";